export const PREVIEW_IN_PROGRESS = 'PREVIEW_IN_PROGRESS';
export const PREVIEW_SUCCESS = 'PREVIEW_SUCCESS';
export const PREVIEW_ERROR = 'PREVIEW_ERROR';
export const UPDATE_VIEW_MODE = 'UPDATE_VIEW_MODE';
